import request from '@/utils/request'

// 查询银河打本偏远省份邮费配置分页
export function pageRemoteProvincePriceConfig(query) {
  return request({
    url: '/played/remote/province/price/config/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本偏远省份邮费配置列表
export function listRemoteProvincePriceConfig(query) {
  return request({
    url: '/played/remote/province/price/config/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本偏远省份邮费配置详细
export function getRemoteProvincePriceConfig(id) {
  return request({
    url: '/played/remote/province/price/config/' + id,
    method: 'get'
  })
}

// 新增银河打本偏远省份邮费配置
export function addRemoteProvincePriceConfig(data) {
  return request({
    url: '/played/remote/province/price/config',
    method: 'post',
    data: data
  })
}

// 修改银河打本偏远省份邮费配置
export function updateRemoteProvincePriceConfig(data) {
  return request({
    url: '/played/remote/province/price/config',
    method: 'put',
    data: data
  })
}

// 删除银河打本偏远省份邮费配置
export function delRemoteProvincePriceConfig(id) {
  return request({
    url: '/played/remote/province/price/config/' + id,
    method: 'delete'
  })
}
